import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import DashboardLayout from "../components/layouts/DashboardLayout";
import routePaths from "../config/routepaths.config";
import { localStorageService } from "../services";
import * as Auth from '../util/Auth';


const DashboardRoute = ({ children }: { children: JSX.Element }) => {
   let location = useLocation();

   const isAuthenticated = Auth.getToken();
   if (!isAuthenticated)
      return (<Navigate to={routePaths.LOGIN} state={{ from: location }} />) as any;
   return (
      <>
         <DashboardLayout>{children}</DashboardLayout>
      </>
   );
};

export default DashboardRoute;
